import GraphicRiverItemCard from './graphicRiverItemCard'

export default GraphicRiverItemCard
